import { render, staticRenderFns } from "./page-noPermission.vue?vue&type=template&id=71db3d1e&scoped=true&"
import script from "./page-noPermission.vue?vue&type=script&lang=js&"
export * from "./page-noPermission.vue?vue&type=script&lang=js&"
import style0 from "./page-noPermission.vue?vue&type=style&index=0&id=71db3d1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71db3d1e",
  null
  
)

export default component.exports